import { useEffect } from 'react';
import useSettingsStore from '../stores/settingsStore';
import WebApp from '@twa-dev/sdk';

export function useMaintenanceCheck() {
	const isMaintenance = useSettingsStore(state => state.isMaintenance);
	const lastChecked = useSettingsStore(state => state.lastChecked);
	const checkMaintenance = useSettingsStore(state => state.checkMaintenance);

	useEffect(() => {
		// Do not make backend requests if running in Telegram Web or unknown platform
		if (WebApp.platform === 'web' || WebApp.platform === 'unknown') return;
		checkMaintenance();
		// Далее — раз в минуту
		const interval = setInterval(() => {
			checkMaintenance();
		}, 60 * 1000);
		return () => clearInterval(interval);
	}, [checkMaintenance]);
	console.log('isMaintenance', isMaintenance);
	return isMaintenance;
} 